import React from 'react';

const People = () => {
  return(
    <article id="people">
      <h1 className="space-left bold">People</h1>
      <section>
        <h2>Instructors</h2>
        <div className="flex people-container">
          <a href="https://www.cs.washington.edu/people/faculty/bruceh" target="_blank" rel="noreferrer">
            <figure className="instructor">
              <img src="./img/people/bruce.jpg" alt="Link to Professor Bruce Hemingways's Site" />
              <figcaption>
                Bruce Hemingway
              </figcaption>
            </figure>
          </a>
          <a href="https://homes.cs.washington.edu/~katielim/" target="_blank" rel="noreferrer">
            <figure className="instructor">
              <img src="./img/people/katie.png" alt="Link to Katie Lim's Site" />
              <figcaption>
                Katie Lim<br />(Pronouns: she/her/hers)
              </figcaption>
            </figure>
          </a>
        </div>
      </section>
      <hr />
      <section>
        <h2>Students</h2>
        <div className="flex people-container">
          <a href="https://www.linkedin.com/in/jin-seong-ahn-089564177/" target="_blank" rel="noreferrer">
            <figure>
              <img src="./img/people/jin.jpg" alt="Link to Jin Seong Ahn's LinkedIn Page" />
              <figcaption>
                Jin Seong Ahn<br />(Pronouns: he/him/his)
              </figcaption>
            </figure>
          </a>
          <a href="https://www.linkedin.com/in/benjamin-j-cooper/" target="_blank" rel="noreferrer">
            <figure>
              <img src="./img/people/benjamin.jpg" alt="Link to Benjamin Cooper's LinkedIn Page" />
              <figcaption>
                Benjamin Cooper<br />(Pronouns: he/him/his)
              </figcaption>
            </figure>
          </a>
          <a href="https://www.linkedin.com/in/waleed-el-himri-243a0b80/" target="_blank" rel="noreferrer">
            <figure>
              <img src="./img/people/waleed.jpg" alt="Link to Waleed EL-Himri's LinkedIn Page" />
              <figcaption>
                Waleed EL-Himri
              </figcaption>
            </figure>
          </a>
          <a href="https://www.linkedin.com/in/michael-fiscus-aa7061171/" target="_blank" rel="noreferrer">
            <figure>
              <img src="./img/people/michael.jpg" alt="Link to Michael Fiscus's LinkedIn Page" />
              <figcaption>
                Michael Fiscus<br />(Pronouns: he/him/his)
              </figcaption>
            </figure>
          </a>
          <a href="https://www.linkedin.com/in/roee-horowitz/" target="_blank" rel="noreferrer">
            <figure>
              <img src="./img/people/roee.jpg" alt="Link to Roee Horowitz's LinkedIn Page" />
              <figcaption>
                Roee Horowitz<br />(Pronouns: he/him/his)
              </figcaption>
            </figure>
          </a>
          <a href="http://linkedin.com/in/alex-cf-hsu" target="_blank" rel="noreferrer">
            <figure>
              <img src="./img/people/alex.png" alt="Link to Alex Hsu's LinkedIn Page" />
              <figcaption>
                Alex Hsu<br />(Pronouns: he/him/his)
              </figcaption>
            </figure>
          </a>
          <a href="https://www.linkedin.com/in/stella-lau/" target="_blank" rel="noreferrer">
            <figure>
              <img src="./img/people/stella.jpg" alt="Link to Stella Lau's LinkedIn Page" />
              <figcaption>
                Stella Lau<br />(Pronouns: she/her/hers)
              </figcaption>
            </figure>
          </a>
          <a href="https://www.linkedin.com/in/trevor-morrow-77961313a/" target="_blank" rel="noreferrer">
            <figure>
              <img src="./img/people/trevor.png" alt="Link to Trevor Morrow's LinkedIn Page" />
              <figcaption>
                Trevor Morrow<br />(Pronouns: he/him/his)
              </figcaption>
            </figure>
          </a>
          <a href="https://www.linkedin.com/in/logan-ricord" target="_blank" rel="noreferrer">
            <figure>
              <img src="./img/people/logan.png" alt="Link to Logan Ricord's LinkedIn Page" />
              <figcaption>
                Logan Ricord<br />(Pronouns: he/him/his)
              </figcaption>
            </figure>
          </a>
          <a href="https://parkersruth.github.io/" target="_blank" rel="noreferrer">
            <figure>
              <img src="./img/people/parker.png" alt="Link to Parker Ruth's Site" />
              <figcaption>
                Parker Ruth<br />(Pronouns: he/him/his)
              </figcaption>
            </figure>
          </a>
          <a href="http://www.linkedin.com/in/zhaojunzhang" target="_blank" rel="noreferrer">
            <figure>
              <img src="./img/people/marshall.png" alt="Link to Marshall Zhang's LinkedIn Page" />
              <figcaption>
                Marshall Zhang<br />(Pronouns: he/him/his)
              </figcaption>
            </figure>
          </a>
        </div>
      </section>
    </article>
  );
}

export default People;
